module.exports = __webpack_public_path__ + "img/send-offers.91134133.svg";